module.exports = __webpack_public_path__ + "images/rbl-bank-logoe8e0ee4575e17723b1d17277fa7f518d.svg";